export default __webpack_public_path__ + "static/media/aeroclub_33.e4a75421.webp";